import React, { useState, useCallback } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import useAppContext from 'flow/hooks/useAppContext';
import { getTextHoverVideo } from 'flow/utils/meeting-utils';
import { toggleSenderVideoActive } from 'flow/actions/meeting-actions';
import { selectVideoSenderVideoActive } from 'flow/selectors/video-selectors';
import { selectVideoAllowed } from 'flow/selectors/meeting-selectors';
import MeetingButton from 'flow/components/meeting/MeetingButton';

export const ButtonToggleCamera = () => {
    const dispatch = useAppDispatch();
    const { i18next } = useAppContext();

    const videoActive = useAppSelector(selectVideoSenderVideoActive);
    const videoAllowed = useAppSelector(selectVideoAllowed);

    const [loadingVideoToggle, setLoadingVideoToggle] =
        useState<boolean>(false);

    const onClick = useCallback(async () => {
        setLoadingVideoToggle(true);

        if (videoAllowed) {
            void dispatch(toggleSenderVideoActive());
        }

        setLoadingVideoToggle(false);
        // Comment from person on git blame: this block is simply copy+paste in a refactor. Seems odd setting loading to true and then to false right after.
        // If someone knows if we want to await toggleSenderVideoActive, feel free to adjust.
    }, [dispatch, videoAllowed]);

    return (
        <div
            className="flex flex-col items-center justify-center text-xs select-none"
            data-test-id={'meeting-camera-button'}
        >
            <MeetingButton
                iconType={videoActive ? 'video_outlined' : 'videocam_off'}
                active={!videoActive}
                callback={!loadingVideoToggle ? onClick : undefined}
                hoverText={getTextHoverVideo(
                    videoAllowed,
                    videoActive,
                    i18next,
                )}
                disabled={!videoAllowed || loadingVideoToggle}
            />
        </div>
    );
};

export default ButtonToggleCamera;
